import React, { useCallback, useMemo, useRef } from 'react';
import type { IProductCardProps } from '../IComponent';
import { fetchProductInfo } from '../fetch';
import type { IProduct as IProductShare } from '@reolink-deps/reolink_web.fe.shared-modules';
import { ProductBox, ProductPopup, ProductTag } from '@reolink-deps/reolink_web.fe.shared-modules';
import { ReoIcon } from '@reolink-web/ui';
import classNames from 'classnames';
import * as Utils from '@reolink-web/utils';
import '../index.less';

const ProductCard: React.FC<IProductCardProps> = (props) => {

    const {
        i18nPackage,
        product,
        allProductInfo,
        country,
        getImg
    } = props;

    // 因为初始化的时候allProductInfo可能为空，所以拿到内部来获取进行判断
    const productInfo = useMemo(() => allProductInfo[product.id] ?? [], [allProductInfo, product.id]);

    const isPc = useMemo(() => props.screenWidth >= 1280, [props.screenWidth]);

    const showPopup = useCallback((data: IProductShare[]): void => {
        ProductPopup.showPopup('variationContent', {
            country,
            productsData: data,
            productKey: product.key,
            hasDescriptions: true,
            langPack: i18nPackage
        });
    }, [country, i18nPackage, product.key]);

    const productCardRef = useRef<HTMLDivElement>(null);
    // 用于缓存数据的map
    const productInfoMap = useRef(new Map());
    // 产品点击事件
    const productClick = useCallback(() => {
        // 如果产品存在速卖通活动，那么就直接跳转速卖通的链接
        // 否则调用接口打开加购弹窗
        const btnEl = productCardRef.current?.getElementsByClassName('tag-aliexpress')[0];
        if (btnEl) {
            (btnEl as HTMLButtonElement).click();
        }
        else {
            // webview环境下
            if (props.isWebview) {
                Utils.CompatibleJump.compatibleJump(product.href, '_self');
                return;
            }
            fetchProductInfo(props.product.key, productInfoMap)
                .then(
                    res => {
                        showPopup(res);
                    },
                    err => {
                        throw err;
                    }
                );
        }
    }, [product.href, props.isWebview, props.product.key, showPopup]);

    return (
        <div
            ref={ productCardRef }
            className={ 'product_list_item' }
            onClick={ productClick }
        >
            <div className='product_list_item_wrap'>
                {/* img box */}
                <div className={ 'product_img_box' }>
                    {
                        isPc && product.image.scene
                            ? (
                                <div className='scene_product_img_wrapper'>
                                    <img
                                        className={ 'scene_product_img' }
                                        alt={ product.name }
                                        src={ product.image.scene }
                                    />
                                </div>
                            )
                            : null
                    }
                    {
                        getImg(product.image)
                            ? (
                                <img
                                    src={ getImg(product.image) }
                                    className={ classNames('normal_product_img', product.image.scene ? 'normal_product_img_not_scene' : '') }
                                    alt={ product.name }
                                />
                            )
                            : (
                                <div className={ 'normal_product_img' } />
                            )
                    }
                </div>

                {
                    isPc ? <div className={ 'product_description' }>{product.profile?.description}</div> : null
                }

                <div className='product-name-box'>
                    <span>{product.name}</span>
                </div>

                {/* 仅在非webview环境下渲染 */}
                {
                    !props.isWebview ? (
                        <>
                            <div className={ 'product_price' }>
                                {/* <p className={'product_name'}>{product.name}</p> */}
                                <div className={ 'price_box' }>
                                    <ProductBox
                                        country={ props.country }
                                        productsData={ productInfo }
                                        productKey={ product.key }
                                        boxExclude={ ['des', 'image', 'tags', 'time', 'tips'] }
                                        panelExclude={ [ 'buttons', 'quantity', 'selector' ] }
                                        buttonSize='small'
                                        langPack={ i18nPackage }
                                    />
                                    <ReoIcon
                                        color='#333333'
                                        width='18px'
                                        name={ 'icon-icon_cart-2' }
                                    />

                                </div>
                            </div>
                            {/* pre-order 10%OFF */}
                            <div className='product-preorder-cust'>
                                <ProductTag
                                    country={ props.country }
                                    include={ ['pre-order', 'discount'] }
                                    productsData={ productInfo }
                                    productKey={ product.key }
                                    langPack={ i18nPackage }
                                />
                            </div>
                        </>

                    ) : null
                }
            </div>
        </div>
    );
};

export default ProductCard;
